import eyeOpen from "../../assets/design-revamp/eye-open.svg";

const ShowTableIcon = ({ style }) => {
  return (
    <>
      <div>
        <img
          className=""
          src={eyeOpen}
          alt=""
          style={{ ...style, width: "20px", height: "20px" }}
        />
      </div>
    </>
  );
};

export default ShowTableIcon;
